import { render, staticRenderFns } from "./GoalValueForm.vue?vue&type=template&id=6313d5ee&scoped=true"
import script from "./GoalValueForm.vue?vue&type=script&lang=ts"
export * from "./GoalValueForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6313d5ee",
  null
  
)

export default component.exports